import { UiState } from '@marketplace-web/shared/ui-state-util'
import { FacetedCategoriesState } from '@marketplace-web/catalog/catalog-data'

import { FacetedCategoriesReducerAction, FacetedCategoriesAction } from './actionTypes'

export const facetedCategoriesReducer = (
  state: FacetedCategoriesState,
  action: FacetedCategoriesAction,
): FacetedCategoriesState => {
  switch (action.type) {
    case FacetedCategoriesReducerAction.FETCH_FACETED_CATEGORIES_REQUEST: {
      return { ...state, uiState: UiState.Pending }
    }
    case FacetedCategoriesReducerAction.FETCH_FACETED_CATEGORIES_SUCCESS: {
      const { categories } = action.payload

      return {
        ...state,
        categories,
        uiState: UiState.Success,
      }
    }
    case FacetedCategoriesReducerAction.FETCH_FACETED_CATEGORIES_FAILURE: {
      return {
        ...state,
        uiState: UiState.Failure,
        error: action.payload.error,
      }
    }
    default:
      return state
  }
}
